import styled from 'styled-components';

import { SkeletonBlurb } from 'components/Containers';

const SkeletonBlock = styled(SkeletonBlurb)<{
  $width?: number | string;
  $height: number;
  $rounding?: number;
}>`
  border-radius: ${({ $rounding }) => ($rounding ?? 4) + 'px'};
  height: ${({ $height }) => $height + 'px'};
  width: ${({ $width }) => (typeof $width === 'number' ? $width + 'px' : ($width ?? '100%'))};
  max-width: 100%;
`;

export function PatientCardSkeleton({ height }: { height?: number }) {
  return (
    <PatientCardContainer $height={height}>
      <SkeletonBlock $height={12} $width={120} />
      <SkeletonBlock $height={11} $width={80} />
    </PatientCardContainer>
  );
}

const PatientCardContainer = styled.div<{ $height?: number }>`
  height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.black5};
  border-left: 3px solid ${({ theme }) => theme.colors.black10};
`;

export function DayViewColumnSkeleton({ count = 5, height }: { count?: number; height?: number }) {
  return (
    <DayViewSkeletonContainer>
      {Array.from({ length: count }).map((_, i) => (
        <PatientCardSkeleton key={i} height={height} />
      ))}
    </DayViewSkeletonContainer>
  );
}

const DayViewSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export function WeekDayColumnHeaderSkeleton() {
  return (
    <>
      <SummaryItem>
        <SummaryDotSkeleton />
        <SummaryTextSkeleton $width={76} />
      </SummaryItem>
      <SummaryItem>
        <SummaryDotSkeleton />
        <SummaryTextSkeleton $width={56} />
      </SummaryItem>
    </>
  );
}

const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const SummaryDotSkeleton = styled(SkeletonBlurb)`
  width: 6px;
  height: 6px;
  border-radius: 3px;
`;

const SummaryTextSkeleton = styled(SkeletonBlurb)<{ $width: number }>`
  height: 12px;
  width: ${({ $width }) => $width}px;
  border-radius: 4px;
`;

/**
 * Skeleton for MonthViewAggregateCard
 */
export function MonthAggregateCardSkeleton() {
  return (
    <AggregateCardContainer>
      <SkeletonBlock $height={12} $width={70} />
    </AggregateCardContainer>
  );
}

const AggregateCardContainer = styled.div`
  padding: 8px 10px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.black5};
  border-left: 3px solid ${({ theme }) => theme.colors.black10};
`;

export function MonthDayCellSkeleton({ showCards = true }: { showCards?: boolean }) {
  return (
    <MonthCellSkeletonContainer>
      {showCards && (
        <>
          <MonthAggregateCardSkeleton />
          <MonthAggregateCardSkeleton />
        </>
      )}
    </MonthCellSkeletonContainer>
  );
}

const MonthCellSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
`;
